import type { SidebarMenuItem } from "@/components/layout/SidebarMenu";
import {
  Users,
  UserCheck,
  BookOpenCheck,
  Package,
  UserSquare,
  LayoutDashboard,
  BarChart3,
} from "lucide-react";
import type { DashboardRole, RoleDashboardConfig } from "../types";

const adminNavItems: SidebarMenuItem[] = [
  {
    label: "Vista General",
    key: "vistaGeneral",
    icon: LayoutDashboard,
    route: "vista-general",
  },
  {
    label: "Clientes Intermedios",
    key: "clienteIntermedios",
    icon: Users,
    route: "clientes-intermedios",
  },
  {
    label: "Clientes Finales",
    key: "clientesFinales",
    icon: UserCheck,
    route: "clientes-finales",
  },
  {
    label: "Programas",
    key: "programas",
    icon: BookOpenCheck,
    route: "programas",
  },
  // {
  //   label: "Actividades",
  //   key: "actividadesProgramas",
  //   icon: ListChecks,
  //   route: "actividades-programas",
  // },
  // {
  //   label: "Aprendices",
  //   key: "aprendices",
  //   icon: GraduationCap,
  //   route: "aprendices",
  // },
  {
    label: "Paquetes",
    key: "paquetes",
    icon: Package,
    route: "paquetes",
  },
  {
    label: "Aprendices Programas",
    key: "aprendicesProgramas",
    icon: UserSquare,
    route: "aprendices-programas",
  },
];

const intermediarioNavItems: SidebarMenuItem[] = [
  {
    label: "Vista General",
    key: "vistaGeneral",
    icon: LayoutDashboard,
    route: "vista-general",
  },
  {
    label: "Clientes Finales",
    key: "clientesFinales",
    icon: Users,
    route: "clientes-finales",
  },
  {
    label: "Gestión Programas",
    key: "gestionProgramas",
    icon: BookOpenCheck,
    route: "gestion-programas",
  },
  {
    label: "Panel Clientes Finales",
    key: "panelClientesFinales",
    icon: BarChart3,
    route: "panel-clientes-finales",
  },
];

const roleDashboardConfig: Record<DashboardRole, RoleDashboardConfig> = {
  SUPER_ADMIN: {
    role: "SUPER_ADMIN",
    basePath: "/admin",
    defaultRoute: "vista-general",
    navItems: adminNavItems,
  },
  INTERMEDIO: {
    role: "INTERMEDIO",
    basePath: "/intermediario",
    defaultRoute: "vista-general",
    navItems: intermediarioNavItems,
  },
};

export const DASHBOARD_ROLES = Object.freeze(
  Object.keys(roleDashboardConfig) as DashboardRole[],
);

export function isDashboardRole(value: unknown): value is DashboardRole {
  return typeof value === "string" && value in roleDashboardConfig;
}

export function getRoleDashboardConfig(
  role: DashboardRole,
): RoleDashboardConfig {
  const config = roleDashboardConfig[role];
  if (!config) {
    throw new Error(`No dashboard config found for role "${role}".`);
  }
  return config;
}

export function getDashboardBasePath(role: DashboardRole): string {
  return getRoleDashboardConfig(role).basePath;
}
